import { createIcon } from '@/utils/factoryUtil'

export const SVGCommonNeutral = createIcon('SVGCommonNeutral', (props) => (
  <svg viewBox='0 0 100 100' {...props}>
    <circle cx='50%' cy='50%' r='50' />
  </svg>
))
